export default __webpack_public_path__ + "static/media/thsarabunnew_italic-webfont.8e4babf8.eot";